import { jsx as _jsx } from "react/jsx-runtime";
import { Switch } from './index';
/**
 * Final form field adaptor.
 * @param props - FieldRenderProps
 * @returns React.FC
 */
export const SwitchField = (props) => {
    const { input: { value, ...input }, meta: _meta, dataTestId, ...other } = props;
    return (_jsx(Switch, { ...input, ...other, checked: !!value, dataTestId: dataTestId ? `${dataTestId}-checked-${!!value}` : `checked-${!!value}` }));
};
